<template>
  <div id="schedule" v-if="scheduleArr.length !== 0">
    <div class="shedule-window">
      <div class="schedule-box" :style="{transform: `translateX(${translateOffset}px)`}">
        <div class="schedule-item"  :class="giveClassName(schedule.status)" v-for="(schedule, index) in localScheduleArr" :key="index">
          <div class="schedule-item-icon"></div>
          <div class="schedule-item-content">
            <div class="schedule-item-title">{{schedule.title}}</div>
            <div class="schedule-item-date">{{schedule.date}}{{ schedule.visa_date_longest && schedule.date !== schedule.visa_date_longest ? `~${schedule.visa_date_longest}` : '' }}</div>
          </div>
        </div>
      </div>
      <div class="shcedule-mask-left"></div>
      <div class="shcedule-mask-right"></div>
    </div>

    <div class="schedule-arrow">
      <div class="schedule-arrow-left" @click="slideScheduleBox(0)"></div>
      <div class="schedule-arrow-right" @click="slideScheduleBox(1)"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scheduleBlock',
  props: {
    scheduleArr: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
  },
  data() {
    return {
      currentOffsetNumber: 0,
    };
  },
  computed: {
    localScheduleArr() {
      const newArr = this.scheduleArr.map(schedule => schedule);
      newArr.forEach((schedule, index) => {
        // schedule.date = schedule.date ? moment(schedule.date).format('YYYY年M月D日'):'';
        if (schedule.status === 1 && index > 2) {
          if (index >= newArr.length - 2) {
            this.currentOffsetNumber = newArr.length - 5;
          } else {
            this.currentOffsetNumber = index - 2;
          }
        }
      });
      return newArr;
    },
    maxOffsetNumber() {
      return this.localScheduleArr.length - 5;
    },
    translateOffset() {
      return this.currentOffsetNumber * -170;
    },
  },
  methods: {
    slideScheduleBox(direction) {
      if ((this.currentOffsetNumber <= 0 && !direction)
          || (this.currentOffsetNumber >= this.maxOffsetNumber && direction)) return;
      if (direction) {
        this.currentOffsetNumber += 1;
      } else {
        this.currentOffsetNumber -= 1;
      }
    },
    giveClassName(status) {
      if (status === 0) return 'schedule-item-undone';
      if (status === 1) return 'schedule-item-doing';
      if (status === 2) return 'schedule-item-done';
    },
  },
};
</script>

<style lang="less" scoped>
#schedule {
  width: 920px;
  height: 126px;
  background-image: url(../../assets/imgs/order-detail/schedule-block/schedule-bg.png);
  // margin-bottom: 14px;
  border-radius: 4px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;

  .shedule-window {
    position: relative;
    width: 830px;
    overflow: hidden;
    height: 126px;
    margin: 0 auto;
    .shcedule-mask-left {
      position: absolute;
      width: 80px;
      height: 126px;
      left: 0px;
      top: 0;
      background-image: url(../../assets/imgs/order-detail/schedule-block/mask-left.png)
    }
    .shcedule-mask-right {
      position: absolute;
      width: 80px;
      height: 126px;
      right: 0px;
      top: 0;
      background-image: url(../../assets/imgs/order-detail/schedule-block/mask-right.png)
    }
  }

  .schedule-box {
    position: absolute;
    left: 47px;
    top: 0;
    height: 126px;
    min-width: 920px;
    padding: 14px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    transition: all 0.4s ease-in-out;

    .schedule-item {
      text-align: center;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 85px;
      margin-right: 85px;
      opacity: 0.8;

      &.schedule-item-done {
        .schedule-item-icon {
          background-image: url(../../assets/imgs/order-detail/schedule-block/done.png);
        }
      }
      &.schedule-item-doing {
        opacity: 1;
        .schedule-item-title {
          font-weight: bold;
        }
        .schedule-item-icon {
          background-image: url(../../assets/imgs/order-detail/schedule-block/doing.png);
          &::after {
            border-top: 1px dashed #ffffff;
          }
        }
      }
      &.schedule-item-undone {
        .schedule-item-icon {
          background-image: url(../../assets/imgs/order-detail/schedule-block/undone.png);
          &::after {
            border-top: 1px dashed #ffffff;
          }
        }
      }
      &:last-of-type {
        .schedule-item-icon {
          &::after {
            border-top: none;
          }
        }
      }

      .schedule-item-icon {
        width: 50px;
        height: 50px;
        background-image: url(../../assets/imgs/order-detail/schedule-block/undone.png);
        background-position: center center;
        background-repeat: no-repeat;
        // background-size: 40px 40px;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 25px;
          left: 55px;
          height: 1px;
          width: 110px;
          border-top: 1px solid #ffffff;
          opacity: 0.8;
        }
      }

      .schedule-item-content {
        height: 36px;
        margin-top: 11px;
        .schedule-item-title {
          font-size: 14px;
          margin-bottom: 8px;
        }
        .schedule-item-date {
          font-size: 12px;
          white-space: nowrap;
        }
      }
    }
  }

  .schedule-arrow {
    height: 27px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 14px;
    div {
      width: 11px;
      height: 27px;
      background: url(../../assets/imgs/order-detail/schedule-block/schedule-arrow.png);
    }
    .schedule-arrow-left {
      transform: rotate(180deg);
      cursor: pointer;
    }
    .schedule-arrow-right {
      cursor: pointer;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/order-detail/schedule-block.vue